import React from 'react';

export function InputRadio({text, name, value, checked, disabled, onChange}) {

  return <label htmlFor={name + "_" + value} className="circle-checkbox">
    <input type="radio" id={name + "_" + value} name={name} checked={checked} className="circle-checkbox__input" disabled={disabled} onChange={() => onChange(name, value)} />
      <span className="circle-checkbox__icon"></span>
      <span className="circle-checkbox__title">{text}</span>
  </label>;
}
